module.exports = __webpack_public_path__ + "static/media/region.380cb00d.webp";